import { Component, OnInit, TemplateRef, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Gym } from '../../../interfaces/gym';
import { GymsService } from '../../../services/gyms.service';
import { Script } from '../../../interfaces/script';
import { TranslateService } from '@ngx-translate/core';
import { AlertsService } from '../../../services/alerts.service';
import { Kiosk } from '../../../interfaces/kiosk';
import { KioskScriptStatus } from '../../../interfaces/kioskscriptstatus';

@Component({
    selector: 'app-modal-force-script',
    templateUrl: 'modal-force-script.html',
})
export class ModalForceScriptComponent {

    kiosk: Kiosk;
    script: Script;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<ModalForceScriptComponent>,
        public gymsService: GymsService,
        public translate: TranslateService,
        public alertsService: AlertsService) {

        this.kiosk = data.kiosk;
        this.script = data.script;
    }

    public modalForceScriptOk() {
        this.forceScript();
        this.dialogRef.close();
    }

    public modalForceScriptCancel() {
        this.dialogRef.close();
    }

    public forceScript() {
        this.gymsService.forceScript(this.script, this.kiosk).subscribe(
            result => {
                const blankKiosk: KioskScriptStatus = {
                    id: 0,
                    kiosk: 0,
                    script: 0,
                    status: 1,
                    result: '',
                    creationDate: ''
                };
                this.kiosk.scriptStatus = blankKiosk;
                this.translate.get('SCRIPTS.KIOSK_SCRIPT_FORCED').subscribe((translation) => {
                    this.alertsService.alertTrigger({ msg: translation, button: 'Ok', time: 8000 });
                });
            },
            error => {
                console.log('Error: forceScript');
                this.translate.get('SCRIPTS.KIOSK_SCRIPT_FORCE_ERROR').subscribe((translation) => {
                    this.alertsService.alertTrigger({ msg: translation, button: 'Ok' });
                });
            }
        );
        this.dialogRef.close();
    }
}

